/**
 * MFA API client.
 *
 * Nothing here caches. Two of these responses carry credentials that exist nowhere else — the TOTP
 * secret and the recovery codes — and a query cache holding either would keep them in memory long
 * after the screen that showed them is gone.
 */

import { request } from '../../api/client';

export interface MfaStatus {
  enrolled: boolean;
  /** Whether **this session** has elevated, not whether the account has MFA. */
  elevated: boolean;
  elevated_until: string | null;
  remaining_recovery_codes: number;
  required_for: string[];
}

export interface EnrolmentOffer {
  secret: string;
  otpauth_uri: string;
}

export function fetchMfaStatus(): Promise<MfaStatus> {
  return request('/auth/mfa');
}

export function beginEnrolment(): Promise<EnrolmentOffer> {
  return request('/auth/mfa/enrolment', { method: 'POST' });
}

export function confirmEnrolment(code: string): Promise<{ recovery_codes: string[] }> {
  return request('/auth/mfa/enrolment/confirm', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });
}

export function elevate(code: string): Promise<{
  elevated: boolean;
  used_recovery_code: boolean;
  remaining_recovery_codes: number;
}> {
  return request('/auth/mfa/elevate', { method: 'POST', body: JSON.stringify({ code }) });
}

export function regenerateRecoveryCodes(): Promise<{ recovery_codes: string[] }> {
  return request('/auth/mfa/recovery-codes', { method: 'POST' });
}

export function disableMfa(code: string): Promise<void> {
  return request('/auth/mfa', { method: 'DELETE', body: JSON.stringify({ code }) });
}
